import { metrics } from '@seek/metrics-js';
import { useTranslations } from '@vocab/react';
import { Button, ButtonIcon, IconCopy, useToast } from 'braid-design-system';

import translations from './.vocab';

export const CopyButton = ({
  profileUrl,
  variant = 'button',
}: {
  profileUrl: string;
  variant?: 'buttonIcon' | 'button';
}) => {
  const showToast = useToast();
  const { t } = useTranslations(translations);

  const onCopyClick = () => {
    navigator.clipboard.writeText(profileUrl);
    showToast({
      key: 'link-copied',
      tone: 'positive',
      message: t('Link copied'),
    });
    metrics.count('shareable_profile_url_copied');
  };

  return variant === 'button' ? (
    <Button
      variant="ghost"
      tone="formAccent"
      icon={<IconCopy />}
      onClick={onCopyClick}
    >
      {t('Copy')}
    </Button>
  ) : (
    <ButtonIcon
      id="copyProfileUrl"
      data={{ automation: 'copy-btn' }}
      variant="transparent"
      bleed={false}
      icon={<IconCopy />}
      label={t('Copy')}
      onClick={onCopyClick}
    />
  );
};
